import * as R from 'ramda'

export const vehicleCoverage: {
  [key: string]: string;
} = {
  NONE: '--None--',
  COMPREHENSIVE_AND_COLLISION: 'Comprehensive and Collision',
  COMPREHENSIVE_ONLY: 'Comprehensive only',
  LIABILITY_ONLY: 'Liability Only'
}

export const vehicleCoverageKeys = R.keys(vehicleCoverage)
export const vehicleCoverageValues = R.values(vehicleCoverage)
